const state = {
    payload: {},
    domainId: 0,
    rootDomainId: 0,
    domain_data: {},
    domain_aliases: {},
    domain_data_full: {},
    environments: [],
    license_settings: {},
    sshKeys: [],
    allowed_envs: []
};

const getters = {
    getEnvironments(state) {
        return state.environments;
    },

    domainId(state) {
        return state.domainId;
    },

    getAllDomainsByDomainId(state) {
        let domains = [];

        if (state.domain_data && state.domain_data.hasOwnProperty("domain_name")) {
            domains.push(state.domain_data.domain_name);
        }

        if (state.domain_aliases[state.domainId].length > 0) {
            domains.push(...state.domain_aliases[state.domainId].map((alias) => alias.alias_name));
        }

        return domains;
    },

    getAllDomains(state) {
        let domains = {};

        let environmentAndOriginal = [];
        environmentAndOriginal.push(...state.environments.map((env) => env.id));
        environmentAndOriginal.push(state.domainId);

        for (let domainId of environmentAndOriginal) {
            if (domains.hasOwnProperty(domainId) === false) {
                domains[domainId] = [];
            }

            if (state.domain_data && state.domain_data.hasOwnProperty("domain_name")) {
                domains[domainId].push(state.domain_data.domain_name);
            }

            if (state.domain_aliases.hasOwnProperty(domainId) && state.domain_aliases[domainId].length > 0) {
                domains[domainId].push(...state.domain_aliases[domainId].map((alias) => alias.alias_name));
            }
        }

        return domains;
    }
};

const mutations = {
    setDomainId(state, domainId) {
        state.domainId = domainId;
    },

    setRootDomainId(state, domainId) {
        state.rootDomainId = domainId;
    },

    setSettings(state, licenseSettings) {
        state.license_settings = licenseSettings;

        state.license_settings = { ...state.license_settings, dev_env_issues_in_progress: false };

        if (!state.license_settings.license_valid || !state.license_settings.dev_compatible) {
            state.license_settings.dev_env_issues_in_progress = true;
        }
    },

    activateTrial(state, trialExpiration) {
        state.license_settings.trial_expiration = trialExpiration;
        state.license_settings.license_valid = true;
        state.license_settings.dev_env_trial_available = false;
    },

    setGitState(state, git_state) {
        this._vm.$set(state.license_settings, "git_enabled", git_state);
    },

    resolveDevEnvIssues(state) {
        state.license_settings.dev_env_issues_in_progress = false;
    },

    setDomainInfo(state, value) {
        state.domain_data = JSON.parse(JSON.stringify(value));
    },

    setFullDomainInfo(state, value) {
        state.domain_data_full = JSON.parse(JSON.stringify(value));
    },

    setDomainAliases(state, payload) {
        let domain_aliases = JSON.parse(JSON.stringify(state.domain_aliases));
        domain_aliases[payload.domainId] = payload.aliases;
        state.domain_aliases = domain_aliases;
    },

    setEnvironments(state, value) {
        state.environments = value;
    },

    setAllowedEnvironments(state, value) {
        state.allowed_envs = value;
    },

    addEnvironment(state, value) {
        state.environments.push(value);
    },

    deleteEnvironment(state, envId) {
        state.environments = state.environments.filter((env) => {
            return !(env.id === envId); /// returns all environments except the one specified ( deleted )
        });
    },

    setSshKeys(state, sshKeys) {
        state.sshKeys = [];
        for (let key in sshKeys) {
            state.sshKeys.push(sshKeys[key]);
        }
    },

    addSshKey(state, value) {
        // this returns the existing ssh keys so we can replace
        // state.sshKeys = value.new_ssh_key;
    }
};

const actions = {
    activateTrial({ commit }) {
        return new Promise((resolve, reject) => {
            this._vm.$axios
                .post(this._vm.$laroute.route("environments.activate_trial"))
                .then((response) => {
                    if (response.data.call_status === "FAILED") {
                        reject("Activate Trial - " + response.data.error);
                    } else {
                        commit("activateTrial", response.data.trial_expiration);
                        resolve();
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        reject("Activate Trial - " + error.response.data.message);
                    } else if (error.request) {
                        reject("Request could not be made - Activate Trial");
                    } else {
                        reject("An unknown error has occured - Activate Trial");
                    }
                });
        });
    },

    convertEntity({ commit }, convert_type) {
        return new Promise((resolve, reject) => {
            this._vm.$axios
                .post(
                    this._vm.$laroute.route("environments.convert_entity", {
                        domain_id: state.domainId
                    }),
                    {
                        convert_type: convert_type
                    }
                )
                .then((response) => {
                    if (response.data.call_status === "FAILED") {
                        reject("Convert Entity - " + response.data.error);
                    } else {
                        //commit("activateTrial", response.data.trial_expiration);
                        resolve();
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        reject("Convert Entity - " + error.response.data.message);
                    } else if (error.request) {
                        reject("Request could not be made - Convert Entity");
                    } else {
                        reject("An unknown error has occured - Convert Entity");
                    }
                });
        });
    },

    setGitState({ commit }, git_state) {
        return new Promise((resolve, reject) => {
            this._vm.$axios
                .post(
                    this._vm.$laroute.route("environments.git_state", {
                        domain_id: state.domainId
                    }),
                    {
                        git_state: git_state
                    }
                )
                .then((response) => {
                    if (response.data.call_status === "FAILED") {
                        reject("Change Git State - " + response.data.error);
                    } else {
                        commit("setGitState", git_state);
                        resolve();
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        reject("Change Git State - " + error.response.data.message);
                    } else if (error.request) {
                        reject("Request could not be made - Change Git State");
                    } else {
                        reject("An unknown error has occurred - Change Git State");
                    }
                });
        });
    },

    getTrackedVariables({ commit }) {
        return new Promise((resolve, reject) => {
            this._vm.$axios
                .get(
                    this._vm.$laroute.route("environments.get_tracked_variables", {
                        domain_id: state.domainId
                    })
                )
                .then((response) => {
                    if (response.data.call_status === "FAILED") {
                        reject("Get Tracked Variables - " + response.data.error);
                    } else {
                        resolve(response.data.variables);
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        reject("Get Tracked Variables - " + error.response.data.message);
                    } else if (error.request) {
                        reject("Request could not be made - Get Tracked Variables");
                    } else {
                        reject("An unknown error has occurred - Get Tracked Variables");
                    }
                });
        });
    },

    saveTrackedVariables({ commit }, tracked_vars) {
        return new Promise((resolve, reject) => {
            this._vm.$axios
                .post(
                    this._vm.$laroute.route("environments.save_tracked_variables", {
                        domain_id: state.domainId
                    }),
                    {
                        variables: tracked_vars
                    }
                )
                .then((response) => {
                    if (response.data.call_status === "FAILED") {
                        reject("Save Tracked Variables - " + response.data.error);
                    } else {
                        resolve();
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        reject("Save Tracked Variables - " + error.response.data.message);
                    } else if (error.request) {
                        reject("Request could not be made - Save Tracked Variables");
                    } else {
                        reject("An unknown error has occurred - Save Tracked Variables");
                    }
                });
        });
    },

    getTrackedFiles({ commit }) {
        return new Promise((resolve, reject) => {
            this._vm.$axios
                .get(
                    this._vm.$laroute.route("environments.get_tracked_files", {
                        domain_id: state.domainId
                    })
                )
                .then((response) => {
                    if (response.data.call_status === "FAILED") {
                        reject("Get Tracked Files - " + response.data.error);
                    } else {
                        resolve(response.data.files);
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        reject("Get Tracked Files - " + error.response.data.message);
                    } else if (error.request) {
                        reject("Request could not be made - Get Tracked Files");
                    } else {
                        reject("An unknown error has occurred - Get Tracked Files");
                    }
                });
        });
    },

    saveTrackedFiles({ commit }, tracked_files) {
        return new Promise((resolve, reject) => {
            this._vm.$axios
                .post(
                    this._vm.$laroute.route("environments.save_tracked_files", {
                        domain_id: state.domainId
                    }),
                    {
                        files: tracked_files
                    }
                )
                .then((response) => {
                    if (response.data.call_status === "FAILED") {
                        reject("Save Tracked Files - " + response.data.error);
                    } else {
                        resolve();
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        reject("Save Tracked Files - " + error.response.data.message);
                    } else if (error.request) {
                        reject("Request could not be made - Save Tracked Files");
                    } else {
                        reject("An unknown error has occurred - Save Tracked Files");
                    }
                });
        });
    },

    getEnvironmentsInitialInfo({ commit }) {
        return new Promise((resolve, reject) => {
            this._vm.$axios
                .get(
                    this._vm.$laroute.route("environments.initial_info", {
                        domain_id: state.domainId
                    })
                )
                .then((response) => {
                    if (response.data.call_status === "FAILED") {
                        reject("Environment Initial Info - " + response.data.error);
                    } else {
                        commit("setAllowedEnvironments", response.data.allowed_envs);
                        commit("setEnvironments", response.data.env_data);
                        commit("setDomainInfo", response.data.domain_data);
                        commit("setDomainAliases", {
                            aliases: response.data.domain_aliases,
                            domainId: state.domainId
                        });
                        commit("setRootDomainId", response.data.domain_data.parent_id);
                        commit("setSettings", response.data.settings);
                        commit("setSshKeys", response.data.ssh_keys);
                        resolve();
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        reject("Environment Initial Info - " + error.response.data.message);
                    } else if (error.request) {
                        reject("Request could not be made - Environment Initial Info");
                    } else {
                        reject("An unknown error has occurred - Environment Initial Info");
                    }
                });
        });
    },

    getAliases({ commit }, domainIdOverwrite) {
        let domainId = state.domainId;
        if (domainIdOverwrite) {
            domainId = domainIdOverwrite;
        }

        return new Promise((resolve, reject) => {
            this._vm.$axios
                .get(
                    this._vm.$laroute.route("ajax_domain_aliases_show", {
                        domain_id: domainId
                    })
                )
                .then((response) => {
                    if (response.data.call_status === "FAILED") {
                        reject("Environment Initial Info - " + response.data.error);
                    } else {
                        commit("setDomainAliases", {
                            aliases: response.data,
                            domainId: domainId
                        });
                        resolve();
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        reject("Environment Initial Info - " + error.response.data.message);
                    } else if (error.request) {
                        reject("Request could not be made - Environment Initial Info");
                    } else {
                        reject("An unknown error has occurred - Environment Initial Info");
                    }
                });
        });
    },

    getEnvironments({ commit }) {
        return new Promise((resolve, reject) => {
            this._vm.$axios
                .get(
                    this._vm.$laroute.route("environments.index", {
                        domain_id: state.rootDomainId
                    })
                )
                .then((response) => {
                    if (response.data.call_status === "FAILED") {
                        reject("getEnvironments - " + response.data.error);
                    } else {
                        commit("setEnvironments", response.data.env_data);
                        resolve();
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        reject("getEnvironments - " + error.response.data.message);
                    } else if (error.request) {
                        reject("Request could not be made - getEnvironments");
                    } else {
                        reject("An unknown error has occured - getEnvironments");
                    }
                });
        });
    },

    getDomainInfo({ commit }) {
        return new Promise((resolve, reject) => {
            this._vm.$axios
                .get(
                    this._vm.$laroute.route("get_quick_domain_info", {
                        domain_id: state.domainId
                    })
                )
                .then((response) => {
                    if (response.data.call_status === "FAILED") {
                        reject("getDomainInfo - " + response.data.error);
                    } else {
                        commit("setDomainInfo", response.data.domain_data);
                        commit("setRootDomainId", response.data.domain_data.parent_id);
                        resolve();
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        reject("getDomainInfo - " + error.response.data.message);
                    } else if (error.request) {
                        reject("Request could not be made - getDomainInfo");
                    } else {
                        reject("An unknown error has occurred - getDomainInfo");
                    }
                });
        });
    },

    getFullDomainInfo({ commit }) {
        return new Promise((resolve, reject) => {
            this._vm.$axios
                .get(
                    this._vm.$laroute.route("get_domain_info", {
                        domain_id: state.domainId
                    })
                )
                .then((response) => {
                    if (response.data.call_status === "FAILED") {
                        reject("getFullDomainInfo - " + response.data.error);
                    } else {
                        commit("setFullDomainInfo", response.data.domain_data);
                        resolve();
                    }
                })
                .catch((error) => {
                    console.log('erorr', error);
                    console.log('erorr response', error.response);
                    if (error.response) {
                        reject("getFullDomainInfo - " + error.response.data.message);
                    } else if (error.request) {
                        reject("Request could not be made - getFullDomainInfo");
                    } else {
                        reject("An unknown error has occurred - getFullDomainInfo");
                    }
                });
        });
    },

    addEnvironment({ commit }, payload) {
        return new Promise((resolve, reject) => {
            this._vm.$axios
                .post(
                    this._vm.$laroute.route("environments.store", {
                        domain_id: state.rootDomainId
                    }),
                    {
                        env_name: payload.env_name
                    }
                )
                .then((response) => {
                    if (response.data.call_status === "FAILED") {
                        reject("addEnvironment - " + response.data.error);
                    } else {
                        commit("addEnvironment", { env_name: payload.env_name, id: response.data.new_dev });
                        resolve();
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    deleteEnvironment({ commit }, env_id) {
        commit("deleteEnvironment", env_id);
    },

    async addSshKey({ commit }, payload) {
        return await this._vm.$axios
            .post(this._vm.$laroute.route("environments.addSshKey"), {
                domain_id: state.rootDomainId,
                ssh_key: payload.ssh_key,
                description: payload.description
            })
            .then((response) => {
                commit("setSshKeys", response.data.ssh_keys);
                return response;
            });
    },

    async removeSshKeys({ commit }, payload) {
        return await this._vm.$axios
            .post(this._vm.$laroute.route("environments.removeSshKeys"), {
                domain_id: state.rootDomainId,
                ssh_keys: payload.ssh_keys
            })
            .then((response) => {
                commit("setSshKeys", response.data.ssh_keys);
                return response;
            });
    },

    load_hooks({ commit }, domain_id) {
        return new Promise((resolve, reject) => {
            this._vm.$axios
                .get(
                    this._vm.$laroute.route("environments.load_hooks", {
                        domain_id: domain_id
                    })
                )
                .then((response) => {
                    if (response.data.call_status === "FAILED") {
                        reject("load_hooks - " + response.data.error);
                    } else {
                        resolve(response);
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    load_default_hooks({ commit }, domain_id) {
        return new Promise((resolve, reject) => {
            this._vm.$axios
                .get(
                    this._vm.$laroute.route("environments.load_default_hooks", {
                        domain_id: domain_id
                    })
                )
                .then((response) => {
                    if (response.data.call_status === "FAILED") {
                        reject("load_default_hooks - " + response.data.error);
                    } else {
                        resolve(response.data.default_hooks);
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    save_default_hooks({ commit }, payload) {
        return new Promise((resolve, reject) => {
            this._vm.$axios
                .post(
                    this._vm.$laroute.route("environments.save_default_hooks", {
                        domain_id: payload.domain_id
                    }),
                    {
                        hook_data: payload
                    }
                )
                .then((response) => {
                    if (response.data.call_status === "FAILED") {
                        reject("save_default_hooks - " + response.data.error);
                    } else {
                        resolve(response.data.default_hooks);
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
